import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';

export const createGoldfishSelector = createSelectorCreator(defaultMemoize, () => false);

export const editModeSelector = state => state.newdashboard.settings.get('editMode');

const getSettings = state => state.newdashboard.settings;

export const settingsSelector = createSelector([
    getSettings,
    editModeSelector
], (settings, editMode) => settings.get(editMode ? 'editable' : 'actual').toJS());

const getBigWidgetSettings = createSelector([
    settingsSelector
], settings => {
    const { deploymentFrequency, leadTime, changeVolume, activities } = settings;
    return { deploymentFrequency, leadTime, changeVolume, activities };
});

const getMainSettings = createSelector([
    settingsSelector
], settings => {
    const { total, successful, failed, meanTime, deploymentDuration, failedRatio, position, visible, active } = settings.main;
    const size = (total && total.visible && total.active ? 1 : 0)
        + (successful && successful.visible && successful.active ? 1 : 0)
        + (failed && failed.visible && failed.active ? 1 : 0)
        + (deploymentDuration && deploymentDuration.visible && deploymentDuration.active ? 1 : 0)
        + (meanTime && meanTime.visible && meanTime.active ? 1 : 0)
        + (failedRatio && failedRatio.visible && failedRatio.active ? 1 : 0);

    return {
        active,
        visible,
        size: {
            x: size,
            y: size <= 8 && size > 1 ? 1 : 2
        },
        position: position || { }
    };
});

const getWidgetSize = display => {
    switch (display) {
        case 'graph':
            return 3;
        case 'summary':
            return 1;
        case 'all':
            return 4;
        default:
            return 0;
    }
}

export const gridSelector = createSelector([getMainSettings, getBigWidgetSettings], (mainSettings, bigWidgetSettings) => {
    const grid = [];
    if (mainSettings.visible && mainSettings.active) {
        grid.push({
            component: 'dbm-summary-widget',
            widget: 'main',
            resizing: {
                enabled: false,
                x: { min: 0, max: 8 },
                y: { min: 0, max: null }
            },
            ...mainSettings
        });
    }

    if (bigWidgetSettings.deploymentFrequency && bigWidgetSettings.deploymentFrequency.display !== 'none' && bigWidgetSettings.deploymentFrequency.active) {
        grid.push({
            component: 'dbm-deployment-frequency-widget',
            widget: 'deploymentFrequency',
            size: {
                x: getWidgetSize(bigWidgetSettings.deploymentFrequency.display),
                y: 3
            },
            position: {
                column: bigWidgetSettings.deploymentFrequency.position.column,
                row: bigWidgetSettings.deploymentFrequency.position.row
            },
            resizing: {
                enabled: false,
                x: { min: 0, max: 8 },
                y: { min: 0, max: null }
            }
        });
    }

    if (bigWidgetSettings.leadTime && bigWidgetSettings.leadTime.display !== 'none' && bigWidgetSettings.leadTime.active) {
        grid.push({
            component: 'dbm-lead-time-widget',
            widget: 'leadTime',
            size: {
                x: getWidgetSize(bigWidgetSettings.leadTime.display),
                y: 3
            },
            position: {
                column: bigWidgetSettings.leadTime.position.column,
                row: bigWidgetSettings.leadTime.position.row
            },
            resizing: {
                enabled: false,
                x: { min: 0, max: 8 },
                y: { min: 0, max: null }
            }
        });
    }

    if (bigWidgetSettings.changeVolume && bigWidgetSettings.changeVolume.display !== 'none' && bigWidgetSettings.changeVolume.active) {
        grid.push({
            component: 'dbm-change-volume-widget',
            widget: 'changeVolume',
            size: {
                x: getWidgetSize(bigWidgetSettings.changeVolume.display),
                y: 3
            },
            position: {
                column: bigWidgetSettings.changeVolume.position.column,
                row: bigWidgetSettings.changeVolume.position.row
            },
            resizing: {
                enabled: false,
                x: { min: 0, max: 8 },
                y: { min: 0, max: null }
            }
        });
    }

    if (bigWidgetSettings.activities && bigWidgetSettings.activities.visible && bigWidgetSettings.activities.active) {
        grid.push({
            component: 'dbm-activity-widget',
            widget: 'activities',
            size: {
                x: bigWidgetSettings.activities.size.width,
                y: bigWidgetSettings.activities.size.height
            },
            position: {
                column: bigWidgetSettings.activities.position.column,
                row: bigWidgetSettings.activities.position.row
            },
            resizing: {
                enabled: true,
                x: { min: 3, max: 8 },
                y: { min: 2, max: 6 }
            }
        });
    }

    return grid.sort((a, b) => a.position.row * 8 + a.position.column - b.position.row * 8 + b.position.column);
});

export const dummyGridSelector = createSelector([gridSelector], () => {
    let i, j;
    const maxRow = 16;
    const dummyGrid = [];
    for (i = 0; i < maxRow; i++) {
        for (j = 0; j < 8; j++) {
            dummyGrid.push({
                dummy: true,
                size: { x: 1, y: 1 },
                position: { column: j, row: i }
            });
        }
    }

    return dummyGrid;
});

export const loadingSelector = createSelector([getSettings], settings => settings.loading);



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/selectors/settings.js